import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getBusinessBottom } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";

export default function BottomParagraphView() {
    const { id, partnerId } = useParams();
    const [bottom, setBottom] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    const fetchBottom = async () => {
      setIsLoading(true);
      if (!Number(id)) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await getBusinessBottom(id);
        setBottom(response.data.data[0]);
      } catch (error) {
       showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to fetch bottom paragraph. Please try again.',
       });
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      fetchBottom();
    }, [id]);

    const columns = ["Part Name", "Content"];
    const rows = [];
    if (bottom && Object.keys(bottom).length > 0) {
      rows.push(["Bottom Title", bottom.paragraph]);
    }
    return (
       <>
        {isLoading ? (
        <CmsCircularProgress />
      ) : (
        <ContentWrapper>
            <BottomTitle>Bottom Title Section</BottomTitle>

            <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
            <ButtonWrapper>
                <Link to={`/${partnerId}/forbusiness`}>
                    <Button variant="secondary">Go Back</Button>
                </Link>
                <Link to={`/${partnerId}/forbusiness/bottomtitle/edit/${id}`}>
                    <Button>{Number(id) ? 'Edit' : 'Add'} bottom section</Button>
                </Link>
            </ButtonWrapper>
        </ContentWrapper>)}
       </>
    );
    }

    const ContentWrapper = styled.div`
    @media (min-width:576px) {
      padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
    justify-content: center;
  `;
  
  const BottomTitle = styled.h3`
    text-align: center;
    padding: 10px 0;
  `;
  
  const ButtonWrapper = styled.div`
    margin: 0 auto;
    padding-top: 40px;
    display: flex;
    gap: 5rem;
    justify-content: center;
     @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
  `;
  